(function (angular) {
    var HeaderController = (function () {
        function HeaderController() {
            this.init.apply(this, arguments);
        }

        HeaderController.prototype = {
            /**
             * 
             * @param $scope
             * @param $element
             * @param $timeout
             * @param MKioskService
             * @param localStorageService
             * @param $message
             * @param $rootScope
             * @param $mdSidenav
             * @param AuthService
             * @param DeviceService{DeviceService}
             * @param NotificationService{NotificationService}
             */
            init: function ($scope, $element, $timeout, MKioskService, localStorageService, $message, $rootScope, $mdSidenav, AuthService, DeviceService, NotificationService) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.localStorageService = localStorageService;
                this.$message = $message;
                this.$rootScope = $rootScope;
                this.$mdSidenav = $mdSidenav;
                this.AuthService = AuthService;
                this.deviceService = DeviceService;
                this.notificationService = NotificationService;

                // Get user from storage
                this.user = this.AuthService.getAuthenticatedUser();

                this.hasMultiConnecting = false;
                this.item = {};
                this.vehicles = [];
                this.ChargeStatus = ChargeStatus;

                var self = this;
                $scope.$watch('vehicles', function (vehicles) {
                    self.vehicles = vehicles;
                    self.updateVehicles(vehicles);
                });

                // NF-819:, Go to prev view if click press backbutton (escapeToClose= true)
                $scope.escapeToClose = angular.isDefined($scope.escapeToClose) ? $scope.escapeToClose : true;
                if($scope.escapeToClose) { // escapeToClose(default: true) 
                    DeviceService.onGoBackButton($scope, ()=>{
                        this.back();
                    });
                }
            },

            toggleLeft: function () {
                // Check count when click "Hamburger" button
                this.notificationService.checkNotificationCount();
         
                this.$mdSidenav("left").open();
            },
            hasManyConnecting: function (vehicles) {
                return _.filter(vehicles, function (vehicle) {
                    return (vehicle.Charging && !vehicle.ChargedByAnotherUser);
                }, this);
            },
            isHasMultiConnecting: function (vehicles) {
                return this.hasManyConnecting(vehicles).length >= 2;
            },
            updateVehicles: function (vehicles) {
                if (this.$scope.showVehicleName) {
                    //Reset value
                    this.$scope.title = "";
                    this.item = {
                        ChargeStatus: "Disconnected"
                    };

                    this.hasMultiConnecting = this.isHasMultiConnecting(vehicles);
                    if (this.hasMultiConnecting) {
                        this.$scope.title = this.hasManyConnecting(vehicles).length + " vehicles charging";
                    } else {
                        if (this.hasManyConnecting(vehicles).length === 1) {
                            var vehicle = this.hasManyConnecting(vehicles)[0];
                            this.$scope.title = vehicle.Model;

                            //Update charge point
                            this.item.ChargingPointId = vehicle.ChargingPointId;
                            this.item.ChargingPointName = vehicle.ChargingPointName;
                            this.item.ChargeStatus = vehicle.ChargeStatus || 'Disconnected';
                            this.item.ChargeWarning = vehicle.ChargeWarning;
                        }
                    }
                }
            },
            back: function () {
                var self = this;
                this.$timeout(function () {
                    if (self.$scope.back) {
                        self.$scope.back();
                    }
                }, 100);
            }
        };
        HeaderController.$inject = ['$scope', '$element', '$timeout', 'MKioskService', 'localStorageService', '$message', '$rootScope', '$mdSidenav', 'AuthService', 'DeviceService', 'NotificationService'];
        return HeaderController;
    }());

    angular.module('shared').directive('nfInternalHeader', function () {
        return {
            restrict: 'E',
            controller: HeaderController,
            templateUrl: 'js/shared/directives/internal-header/header.html',
            transclude: true,
            scope: {
                'hideBackButton': '@',
                'title': '@',
                'back': '&',
                'showVehicleName': '@',
                'visibleVehicleStatus': '@',
                'vehicles': '=',
                'escapeToClose': '=?' // (default: true)
            },
            link: function (scope, elem, attr, ctrl, $transclude) {
                $transclude(function (clone) {
                    scope.hasTranscluded = clone.length ? true : false;
                });
            }
        };
    });

}(angular));
